import React, { Component } from 'react';
import { Container, Row, Col, Pagination } from 'react-bootstrap';
import PublicEvents from '../components/pubevent/PublicEvents';
import '../css/style.css';
import '../components/Home.css';
import { getURL } from '../backend/Backend';
import PublicEventShowItem from '../components/pubevent/PublicEventShowItem';



class WithSearchLayout extends Component {

  constructor(props) {
    super(props);
    this.searchEvents = this.searchEvents.bind(this);
    this.searchItems = this.searchItems.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.goBack = this.goBack.bind(this);
    

    this.state = {
      events: [],
      selected:'',
      activePage: 1,
      totalPages: 0
    };
  }

  async componentDidMount() {
      this.searchEvents(1);
  }
  

 async pageChanged(e) {
  this.searchEvents( e.target.text);
}

  async searchEvents( page) {

    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }
    const response = await fetch(getURL(`${this.props.preURL}/${this.props.id}/${page - 1}`));
    const json = await response.json();
    let oldState = this.state;
    this.setState({
      ...oldState,
      events: json.content,
      selected:'',
      totalPages: json.totalPages,
      activePage: page
    }); 

  }

  async searchItems(criteria, page) {

    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }

    console.log("criteria2:" + JSON.stringify(criteria));

    let converted = criteria.eventCategory ? criteria.eventCategory : '';
    converted += "--";
    converted += criteria.city ? criteria.city : '';
    converted += "--";
    converted += criteria.startDate ? criteria.startDate : '';

    const response = await fetch(getURL(`p-events/search/${converted}/${page - 1}`));
    const json = await response.json();
    console.log("received json: " + JSON.stringify(json));
    let oldState = this.state;
    this.setState({
      ...oldState,
      events: json.content,
      selected:'',
      totalPages: json.totalPages,
      activePage: page,
      criteria: criteria
    });

  }


  selectItem(e){
    let oldState = this.state;
    
    this.setState({
      ...oldState,
    selected: e.id
    })
  }

   goBack(){
    let oldState = this.state;
  
    this.setState({
      ...oldState,
    selected: ''
    })
  }

  render() {
    return (
      <div >
        <Container fluid className="fluid container-fluid2">

       
          <Row className="fluid container-fluid2" >
            <Col   >
            { this.state.selected  ? 
              <PublicEventShowItem id={this.state.selected}  goBack= {this.goBack} />
              :
              <div>
                <PublicEvents events={this.state.events} selectItem={this.selectItem} edit={this.props.edit}/>
                <Pagination onClick={this.pageChanged}>
                  {this.state.activePage > 1 ?
                    <Pagination.Item>{'<'}</Pagination.Item>
                    : ""
                  }

                  {[...Array(this.state.totalPages).keys()].map(i => {
                    return <Pagination.Item active={(i + 1) === this.state.activePage} key={i} >{i + 1}</Pagination.Item>
                  })
                  }
                  {this.state.activePage < this.state.totalPages ?
                    <Pagination.Item>{'>'}</Pagination.Item>
                    : ""
                  }

                </Pagination>
              </div>
             }
            </Col>
           
          </Row>
        
        </Container>
      </div>
    );
  }
}

export default WithSearchLayout;